import { ConsentLevel, useConsentGiven } from '@news-mono/web-common'
import React from 'react'
import { LoggerContext } from '../../../diagnostics/LoggerContext'
import { ConsentFallback } from '../../../tracking/ConsentFallback/ConsentFallback'
import { TextLink } from '../../../typography/TextLink/TextLink'
import { OEmbedResult } from '../helpers/oembed'

export interface SpotifyProps {
    link: string
}

export const isSpotify = (link: string) => {
    return link.indexOf('spotify.com') >= 0
}

export const Spotify: React.FC<SpotifyProps> = ({ link }) => {
    const logger = React.useContext(LoggerContext)
    const [spotifyHtml, setSpotifyHtml] = React.useState('')

    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    React.useEffect(() => {
        async function getSpotifyOembed() {
            try {
                const spotifyUrl = encodeURIComponent(link)

                const oembedRequest = await fetch(
                    `https://open.spotify.com/oembed?url=${spotifyUrl}`,
                )

                const spotifyResp = (await oembedRequest.json()) as OEmbedResult

                const html = spotifyResp.html

                if (html) {
                    setSpotifyHtml(html)
                }
            } catch (error) {
                logger.debug({ error, link }, 'Error loading spotify post')
            }
        }

        getSpotifyOembed()
    }, [consentGiven, link, logger])

    if (!consentGiven) {
        return <ConsentFallback />
    }

    if (!spotifyHtml) {
        return (
            <TextLink href={link} openInNewWindow={true}>
                Loading Facebook Embed
            </TextLink>
        )
    }

    if (spotifyHtml) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: spotifyHtml,
                }}
            />
        )
    }

    return null
}
